import { gql } from "@apollo/client";

export const CREATE_MINUTA_MASIVA = gql`
  mutation CreateMinutaMasiva ($minutaInput: [MinutaMasivaInput!]!
  ){
    createMinutaMasiva(minutaInput: $minutaInput) {
      success,
      valorEsperado,
      error
    }
}
`;